import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const ContactCandidateModalLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "ContactCandidateModal" */
      './ContactCandidateModal'
    ),
  loading: LoadingModal,
});
